<script>
    import refcodesMixin from './refcodes.vue';
    export default {
        mixins: [
            refcodesMixin
        ],
        data () {
            return { delimiter: ':', };
        },
        methods: {
            /**
             * Retrieve a list of referenceCodes based on name/language combination
             * Used for filling drop-down lists
             * @param {any} _name  ref-code name
             * @param {any} _language ref-code language
             * @returns {Promise} promise object
             */
            getRefCodes(_name) {
                return new Promise((resolve, reject) => {
                    // get all refcodes for this name
                    const refcodes = this.$_getRefcodesByName(_name);
                    if (refcodes && refcodes.length > 0) {
                        resolve({ data: refcodes });
                    } else {
                        console.log(`getRefCodes not found: ${_name}`);
                        resolve({ data: [] });
                    }
                });
            },

            /**
             * Retrieve a single referenceCode based on name/language/code combination
             * Replaces param-templates with param-values when applicable
             * For example C6:30:46 has refCode=C6, param1=30, param2 = 46
             * The param values replace the templates in the refCode description
             * @param {any} refCode the refCode (with or without parameters)
             * @param {any} refCodeList the refCodeList as retrieved from db
             * @returns {object} refCode
             */
            getRefCodeFromList(refCode, refCodeList) {
                if (refCode.includes(this.delimiter)) {
                    // Replace param-template with values
                    return this.getParameterizedRefCode(refCode, refCodeList);
                } else {
                    // Return directly from refcodeList
                    return refCodeList.find(s => s.code === refCode);
                }
            },

            /**
             * Changes the refCode description: replaces param-templates with param-values
             * @param {any} refCode the refCode with parameters
             * @param {any} refCodeList the refCodeList as retrieved from db
             * @returns {object} refCode with filled parameters in description
             */
            getParameterizedRefCode(refCode, refCodeList) {
                // Split refCode from parameter values, expects: code:value1:value2
                const tokens = refCode.split(this.delimiter);
                const code = tokens[0];
                const paramValues = tokens.slice(1);
                // Find value from refCodeList, deep copy
                let returnVal = refCodeList.find(s => s.code === code);
                if (returnVal) {
                    returnVal = JSON.parse(JSON.stringify(returnVal));
                }
                // Find param templates
                const paramTemplates = returnVal.description.match(/{(.*?)}/g);
                // Replace param templates by values
                if (paramTemplates) {
                    for (var i = 0; i < paramTemplates.length; i++) {
                        returnVal.description = returnVal.description.replace(paramTemplates[i], paramValues[i]);
                    }
                }
                return returnVal;
            }
        }
    };
</script>
